// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"da4183e4","905":"98d879e6"}[chunkId] + ".chunk.js";
};